var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconVibrate = function SvgIconVibrate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.875 5.25a.5.5 0 0 0-.5-.5h-6.75a.5.5 0 0 0-.5.5v13.5a.5.5 0 0 0 .5.5h6.75a.5.5 0 0 0 .5-.5zm-.5-2.5a2.5 2.5 0 0 1 2.5 2.5v13.5a2.5 2.5 0 0 1-2.5 2.5h-6.75a2.5 2.5 0 0 1-2.5-2.5V5.25a2.5 2.5 0 0 1 2.5-2.5zm5.25 5.625a1 1 0 0 1 1 1v5.25a1 1 0 1 1-2 0v-5.25a1 1 0 0 1 1-1m-16.25 1a1 1 0 0 0-2 0v5.25a1 1 0 1 0 2 0z",
    clipRule: "evenodd"
  })));
};
export default SvgIconVibrate;